import React, { useState, useEffect } from "react";
import useHttp from "../../hooks/use-http";
import { toast } from "react-toastify";
import { utils, read } from "xlsx";
import ReactFileReader from "react-file-reader";
import Pagination from "../../components/Pagination";
import moment from "moment";

const FarmerPlotUploadFMN = () => {
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [formData, setFormData] = useState();
  const [areaData, setAreaData] = useState([]);  
  const [departmentData, setDepartmentData] = useState([]);  
  const [designationData, setDesignationData] = useState([]);  
  const [seasonData, setSeasonData] = useState([]);  
  
  
  const [regionData, setRegionData] = useState([]);
  const [variety, setVariety] = useState([]);
  
  const[farmerData,setFarmerData] = useState([]);
  var d = new Date();
  var dateString =
    d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear() +" "+d.getHours() + ":"+d.getMinutes()+ ":"+d.getSeconds();


  
  const {

      sendRequest: getArea,
    } = useHttp();
  



  const {

    sendRequest: getRegion,
  } = useHttp();

  useEffect(() => {
    getRegion(
      {
        url: `/api/procurementRegionList/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("region", data);

        setRegionData(data.data);
      
      }
    );
  }, [getRegion]);



  const {

    sendRequest: getvarieties,
  } = useHttp();

  useEffect(() => {
    getvarieties(
      {
        url: "/api/varieties/",
      },
      (data) => {
        //console.log("region", data);

        setVariety(data);
      
      }
    );
  }, [getvarieties]);


  
  const {

    sendRequest: getfarmer,
  } = useHttp();

  useEffect(() => {
    getfarmer(
      {
        url: `/api/farmerListForSelection/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        console.log("farmerListForSelection", data);

        setFarmerData(data);
      
      }
    );
  }, [getfarmer]);

  useEffect(() => {
      getArea(
        {
          url: `/api/areaDetails/?orgId=${localStorage.getItem("orgId")}`,
        },
        (data) => {
          //console.log("region", data);
  
          setAreaData(data);
        
        }
      );
    }, [getArea]);
  

    const {

      sendRequest: getDesignation,
    } = useHttp();

    
    useEffect(() => {
      getDesignation(
        {
          url: `/api/designation/?orgId=${localStorage.getItem("orgId")}`,
        },
        (data) => {
          // console.log(data);
          setDesignationData(data);
        }
      );
    }, [getDesignation]);


    const {

      sendRequest: getDepartment,
    } = useHttp();

    useEffect(() => {
      getDepartment(
        {
          url: `/api/department/?orgId=${localStorage.getItem("orgId")}`,
        },
        (data) => {
          //console.log(data);
          setDepartmentData(data);
        }
      );
    }, [getDepartment]);
  

  const { sendRequest: getEmp } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setEmployeeData(data.output);
      }
    );
  }, [getEmp]);





  const {

    sendRequest: getSeasonList,
  } = useHttp();

  useEffect(() => {
    getSeasonList(
      {
        url: `/api/seasons/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
         setSeasonData(data);
      }
    );
  }, [getSeasonList]);


  function generateUniqueID() {
    const currentDateTime = new Date();
    const uniqueID =
      currentDateTime.getTime() + Math.floor(Math.random() * 1000);

    return uniqueID.toString();
  }

  const handleFileRead = (e) => {
    const content = e.target.result;
    const workbook = read(content, { type: "binary" });
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    const parsedData1 = utils.sheet_to_json(worksheet, { header: 1 });
    
    const parsedData=parsedData1.filter(item=>item[0]!="");
    console.log(parsedData);
    setData(parsedData);
    setAllData(parsedData);
   
    const headers = parsedData[0];
    var tempplotId= generateUniqueID ()
    var counterId=1;
    const jsonData = parsedData.slice(1).map((row,index) => {
     
    

      const employeeCode= row[headers.indexOf("Employee Code")];
       
      var farmerNo= row[headers.indexOf("Farmer Code")];
      console.log("farmerNo",farmerNo)  
       
       
      const fieldExecutive = employeeData.find(
        (employee) => employee.employeeCode === employeeCode
      );
      

      console.log("farmerData",farmerData) 
      
      const farmerobj = farmerData.find(
        (farmerItem) => farmerItem.farmerNo === farmerNo
      );

      console.log("farmerobj",farmerobj) 

      if (farmerobj)
      {
      
      var latitude  = row[headers.indexOf("Latitude")];
      var longitude = row[headers.indexOf("Longitude")];
      var plotCoordinates='[{\"latitude\":'+latitude+',\"longitude\":'+longitude+'}]';

      var plotId=tempplotId+counterId.toString()
      counterId=counterId+1;
        
       
      var rdate=row[headers.indexOf("Registration Date")]
      console.log("rdate",rdate) 
       
      let registration_date = new Date(Math.round((rdate - 25569) * 864e5));
      registration_date = moment(registration_date).format('DD/MM/YYYY')
      // registration_date=rdate
      console.log("registration_date",registration_date) 
       
      var cropsDetails ='[{\"cropType\":\"Grains\",\"cropName\":\"Wheat\",\"cropVariety\":\"Borlaug\",\"cropVarietyId\":\"8\",\"cropMasterId\":\"4\",\"sowingDate\":\"\",\"transplantingDate\":\"\",\"pruningDate\":\"\",\"harvestingDate\":\"\",\"surveyNumberGutNumber\":\"\",\"plantCount\":\"\",\"growthType\":\"\",\"seasonId\":\"2\",\"farmerInputTemplateId\":\"9\",\"woodlotsPlantedTrees\":\"\",\"woodlotsPlantedTreeCount\":\"\",\"targetTreeSeedlings\":\"\",\"estimateYieldInKg\":\"\",\"class1Rate\":1.0,\"class2Rate\":1.0,\"class3Rate\":1.0,\"class4Rate\":0.0,\"classUnitId\":2}]'

      const cropList={
         
        cropId :plotId,
        cropMasterId:4 , 
        cropVarietyId:8, 
        plotId :plotId,
        cropType:"Grains",         
        cropName:"Wheat", 
        cropVariety:"Borlaug", 
        class1Rate:1.0,
        class2Rate:1.0,
        class3Rate:1.0,
        class4Rate:1.0,
        classUnitId:2,         
        seasonId:2,
        farmerInputTemplateId:9, 
        woodlotsPlantedTreeCount:0,
        estimateYieldInKg:0,
        growthType:"None",
        plantCount:0,

      }
      const employee = {
        plotId:plotId,
        farmerId:farmerobj.farmerId,
        mappingDate:registration_date, 		        
        plotName: farmerNo ,  //row[headers.indexOf("Plot Id")],
        plotArea:row[headers.indexOf("Farm Size")],
        plotAreaUnit:"Ha",        
        landOwnership :row[headers.indexOf("Land Ownership")]	,
        farmLocation:row[headers.indexOf("Farm Address/Farm Location")],
        landPreparationType:row[headers.indexOf("Land Preparation Type")]	,        
        soilType:row[headers.indexOf("SoilType")]	,
        soilTexture:row[headers.indexOf("soilTexture")]	,
        irrigationSource:row[headers.indexOf("Irrigation Source")]	,
        landMark :row[headers.indexOf("LandMark")]	,
        plotCoordinates:plotCoordinates,
        cropsDetails:cropsDetails ,		         
        plotPhotosUrls:'[\"\"]',
        plotPhotosFiles:'[\"\"]',
        orgId: localStorage.getItem("orgId"),
        empId:fieldExecutive.empId,
        createdBy:fieldExecutive.userId,
        fieldExecutiveId:fieldExecutive.userId,
        createdDate: dateString,
        cropList:cropList,  
       };
      
      return employee;
      }
      return null;
    });
    console.log(jsonData);

    
    setFormData(jsonData);
  };




  const handleFileUpload = (files) => {
    const file = files[0];
    const fileReader = new FileReader();
    fileReader.onloadend = handleFileRead;
    fileReader.readAsBinaryString(file);
  };
  const [itemsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber); 
  };

  const { sendRequest: postAddFarmeer } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    postAddFarmeer(
      {
        url: "/api/uploadFarmerPlotfmn/",
        method: "POST",
        body: formData,
      },
      (data) => {
        toast.success(`Farmeer added successfully`);
        setFormData("");
        setData([]);
      }
    );
  };
  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">&nbsp;
                <form onSubmit={submitHandler}>
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-10">   <label className="card-title mx-2 my-3 ">
                          FMN Farmer Plot FMN Details
                        </label></div>

                        <div className="col-2">
                          <ReactFileReader
                            handleFiles={handleFileUpload}
                            fileTypes={".xlsx"}
                          >
                            <button
                              type="button"
                              className="btn  btn-primary mx-2 my-2"
                            >
                              Upload Excel
                            </button>
                          </ReactFileReader>{" "}
                        </div>
                      </div>

                      <div className="row">
                        <table className="table table-bordered table-responsive text-center table-sm">
                          <thead>
                            <tr className="tableheaderrowview">
                              {data[0] &&
                                data[0].map((header, index) => (
                                  <th key={index}>{header}</th>
                                ))}
                            </tr>
                          </thead>
                          <tbody>
                            {data &&
                              data.slice(1).map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                  {row.map((cell, cellIndex) => (
                                    <td key={cellIndex}>{cell}</td>
                                  ))}
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    {/* /.card-body */}
                    <div className="card-footer clearfix">
                      <Pagination
                        totalItems={data.length}
                        itemsPerPage={itemsPerPage}
                        onPageChange={paginate}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                      />
                    </div>
                  </div>

                  <div className="text-center">
                    <button className="btn  btn-primary mx-2 my-2" type="submit">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FarmerPlotUploadFMN;
